module.exports = __webpack_public_path__ + "static/media/MC.f1120078.svg";